<template>
    <div ref="contextMenu" style="display:none" class="context-menu" >
        <div class="px-4 py-2"><a :href="link" target="_blank">{{ $t("rightClick.tab") }}</a></div>
        <div class="px-4 py-2"><div @click="copy()">{{ $t("rightClick.copy") }}</div></div>
    </div>
</template>

<script>

export default {
    props: {
        link: {
            type: String,
            required: true
        },
        elementId: {
            type: String,
            required: true
        }
    },
    mounted: function () {
        document.getElementById(this.elementId).onclick = this.hideMenu;
        document.getElementById(this.elementId).oncontextmenu = this.rightClick;
    },
    methods: {
        copy: function(){
            navigator.clipboard.writeText(this.link);
        },
        hideMenu: function () {
            if (this.$refs.contextMenu) {
                this.$refs.contextMenu.style.display = "none"
            }
        },
        rightClick: function(e) {
            e.preventDefault();

            // remove others right clicks
            var elements = document.getElementsByClassName('context-menu');
            for (var i = 0; i < elements.length; i++){
                elements[i].style.display = "none";
            }

            if (this.$refs.contextMenu.style.display == "block")
                this.hideMenu();
            else {
                var menu = this.$refs.contextMenu

                menu.style.display = 'block';
                menu.style.left = e.pageX + "px";
                menu.style.top = e.pageY + "px";
            }
        }
    }
}
</script>

<style lang="scss">
.context-menu {
    padding: 10px 0px !important;
    position: absolute;
    z-index: 1000000;
    border: 1px solid #ddd;
    background-color: white;
    border-radius: 4px;
    a {
        text-decoration: none;
        color: black;
    }
    div:hover {
        background: #f5f5f5;
    }
}
</style>